<ng-container *ngIf="!loading">
    <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4 mb-4">
        <div
            class="shadow-md rounded-md p-4"
            [ngClass]="{
            'bg-gray-50/75': !page?.darkMode,
            'bg-gray-800': page?.darkMode,
            'text-white': page?.darkMode,
            'text-black': !page?.darkMode,
            'border-gray-200': !page?.darkMode,
            'border-gray-700': page?.darkMode,
            'hover:bg-gray-700': page?.darkMode,
            'hover:bg-gray-100': !page?.darkMode,
        }"
            *ngFor="let job of jobs?.data">
            <h3 class="text-lg font-semibold cursor-pointer"><a [routerLink]="['jobs', job.slug]">{{ job.title }}</a></h3>
            <p
                class="text-sm"
                [ngClass]="{
                'text-gray-300': page?.darkMode,
                'text-gray-500': !page?.darkMode,
            }">
                {{ job.location }}
            </p>
        </div>
        <p
            class="my-4 text-sm"
            [ngClass]="{
            'text-gray-300': page?.darkMode,
            'text-gray-500': !page?.darkMode,
        }"
            *ngIf="!jobs?.data.length"
            i18n>
            There are no available vacancies which match your criteria.
        </p>
    </div>
</ng-container>

<ng-container *ngIf="loading">
    <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4 mb-4">
        <app-job-cards-husk *ngFor="let job of jobs?.data" [darkMode]="page?.darkMode"></app-job-cards-husk>
    </div>
</ng-container>

<app-paginator
    [length]="length"
    [pageSize]="component.resultsPerPage || 10"
    [component]="component"
    [pageSizeOptions]="pageSizeOptions"></app-paginator>
